module.exports = __webpack_public_path__ + "static/4-3ca7aaf9a9955bb9f6b701aaf4906c67.png";